'use client';

import React from 'react';
import { useParams, usePathname } from 'next/navigation';
import Link from '@/components/atoms/link';
import HomeIcon from '@/components/icons/home';
import UserIcon from '@/components/icons/loading-icon/user';
import CartIcon from '@/components/icons/loading-icon/cart';
import PhoneIcon from '@/components/icons/loading-icon/phone';
import useCart from '@/lib/hooks/useCart';
import { useStoreAndBusinessUnits } from '@/providers/store-and-business-units';
import { useCartConfig } from '@/providers/cart-config/CartConfigContext';

const MobileNavigationMenu = () => {
  const pathname = usePathname();
  const { locale } = useParams();
  const isCreateProfile = pathname?.includes('/create-profile');
  const isLoginPage = pathname?.includes('/login');
  const { isCartEnabled } = useCartConfig();
  const { selectedBusinessUnit } = useStoreAndBusinessUnits();
  const { totalItems: totalCartItems } = useCart(
    selectedBusinessUnit?.key,
    locale === "au" ? "plumbershub-au" : "plumbershub-nz"
  );

  if (isCreateProfile || isLoginPage) return null;

  const navigationItems = [
    {
      label: 'Home',
      href: '/',
      icon: HomeIcon,
      isCart: false,
    },
    {
      label: 'User',
      href: '/profile-settings',
      icon: UserIcon,
      isCart: false,
    },
    {
      label: 'Cart',
      href: '/cart',
      icon: CartIcon,
      isCart: true,
    },
    {
      label: 'Phone',
      href: '/contact-us',
      icon: PhoneIcon,
      isCart: false,
    },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-[999] bg-[#F3EDE9] lg:hidden">
      <div className="flex items-center justify-around h-[62px] px-4">
        {navigationItems.filter(item => !item.isCart || isCartEnabled).map((item) => {
          const Icon = item.icon;

          if (item.isCart) {
            const digitCount = totalCartItems.toString().length;
            const topPosition = digitCount === 3
              ? "calc(50% - 30px)"
              : digitCount >= 4
                ? "calc(50% - 35px)"
                : "calc(50% - 24px)";

            return (
              <Link
                key={item.href}
                link={item.href}
                className="relative flex flex-col items-center justify-center flex-1 h-full"
              >
                <Icon className={`w-[24px] h-[24px] text-[#090909]`} />
                {totalCartItems > 0 && (
                  <div
                    className="absolute flex items-center justify-center"
                    style={{
                      background: "red",
                      borderRadius: "50%",
                      color: "white",
                      fontSize: "10px",
                      fontWeight: 500,
                      right: "calc(50% - 18px)",
                      top: topPosition,
                      padding: "4px",
                      minWidth: "18px",
                      minHeight: "18px",
                      aspectRatio: "1 / 1",
                      lineHeight: "1",
                    }}
                  >
                    {totalCartItems}
                  </div>
                )}
              </Link>
            );
          }

          return (
            <Link
              key={item.href}
              link={item.href}
              className="flex flex-col items-center justify-center flex-1 h-full"
            >
              <Icon
                className={`w-[24px] h-[24px] text-[#090909]`}
              />
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNavigationMenu;
